import { formatDateToIsoString } from "@/helpers/helpers";

export default {
  requestQueryParams() {
    const params = new URLSearchParams();

    if (this.filters.keyword !== "" && this.filters.keyword !== null) {
      params.set("keyword", this.filters.keyword);
    }

    if (this.filters.advanced.name !== null) {
      params.set("name", this.filters.advanced.name);
    }

    if (this.filters.advanced.branch !== null) {
      params.set("branch", this.filters.advanced.branch);
    }

    if (this.filters.advanced.responsible !== null) {
      params.set("responsible", this.filters.advanced.responsible.id);
    }

    if (this.filters.advanced.pipeline.length > 0) {
      this.filters.advanced.pipeline.forEach((element) =>
        params.append("pipeline", element.value)
      );
    }

    if (this.filters.advanced.talentPlatformProfile !== null) {
      params.set(
        "talentPlatformProfile",
        this.filters.advanced.talentPlatformProfile
      );
    }

    if (
      this.filters.advanced.date != null &&
      this.filters.advanced.date.length > 0
    ) {
      const startDate = this.filters.advanced.date[0];
      const endDate = this.filters.advanced.date.at(-1);
      params.set("startDate", formatDateToIsoString(new Date(startDate)));
      params.set("endDate", formatDateToIsoString(new Date(endDate)));
    }

    if (this.filters.advanced.companySector !== null) {
      params.set("companySector", this.filters.advanced.companySector);
    }

    return params;
  },
};
